import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import Radium from "radium";
import styleWrap from "../../globalHelpers/GlobalStyleWrapper";
import RolesHelper from "../../globalHelpers/RolesHelper";
import LabelHelper from "./LabelHelper";
import { subscribe } from "../../globalHelpers/LanguageHelper";

const widgetCache = {};

class WidgetViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            renderWidget: null,
        };
    }

    componentDidMount() {
        this.fetchWidget(this.props.widgetName, this.props);

        subscribe((results) => {
            if (!this.state.language || this.state.language != results) {
                this.setState({ language: results });
            }
        });
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps.widgetName != this.props.widgetName ||
            (newProps.widget.customWidgetName &&
                newProps.widget.customWidgetName !==
                    this.props.widget.customWidgetName)
        ) {
            this.fetchWidget(newProps.widgetName, newProps);
        }
    }

    fetchWidget(widgetName, props) {
        try {
            if (!widgetName) return;

            Express.callPublic("fetch-widget", { widgetName }, (widget) => {
                Express.callPublic(
                    "fetch-component",
                    { componentName: "WidgetWrapper" },
                    (component) => {
                        this.importRenderWidget(widgetName, widget, props);
                        styleWrap(component.style, (styleMap) => {
                            component.style = styleMap;
                            this.setState({ widget, widgetWrapper: component });
                        });
                    }
                );
            });
        } catch (e) {
            console.log(e);
        }
    }

    async importRenderWidget(widgetName, widgetSettings, props) {
        try {
            if (!widgetName) {
                this.setState({ renderWidget: "Widget not found." });
                return;
            }

            if (widgetCache[widgetName]) {
                this.createRenderWidget(
                    widgetCache[widgetName],
                    widgetSettings,
                    props
                );
                return;
            }

            const widgets = await new Promise((resolve) => {
                import("../Widgets/" + widgetName)
                    .then((widget) => {
                        widgetCache[widgetName] = widget;
                        this.createRenderWidget(widget, widgetSettings, props);
                        resolve(true);
                        return;
                    })
                    .catch((err) => {
                        resolve(false);
                        // console.log(err);
                    });
            });

            if (!widgets) {
                import("../CustomWidgets/" + widgetName)
                    .then((widget) => {
                        widgetCache[widgetName] = widget;
                        this.createRenderWidget(widget, widgetSettings, props);
                        return;
                    })
                    .catch((err) => {
                        // console.log(err);
                    });

                import("../AgentPortal/" + widgetName)
                    .then((widget) => {
                        widgetCache[widgetName] = widget;
                        this.createRenderWidget(widget, widgetSettings, props);
                        return;
                    })
                    .catch((err) => {
                        // console.log(err);
                    });

                import("./" + widgetName)
                    .then((widget) => {
                        widgetCache[widgetName] = widget;
                        this.createRenderWidget(widget, widgetSettings, props);
                        return;
                    })
                    .catch((err) => {
                        // console.log(err);
                    });
            }
        } catch (e) {
            console.log(e);
            this.setState({ renderWidget: "Widget not found." });
        }
    }

    createRenderWidget(widget, widgetSettings, props) {
        try {
            try {
                const widgetElement = React.createElement(widget.default, {
                    widgetSettings,
                    pageSettings: this.props.widget,
                    ...props,
                });

                this.setState({ renderWidget: widgetElement });
            } catch (e) {
                console.log(e);
            }
        } catch (e) {
            console.log(e);
        }
    }

    widgetHeader() {
        try {
            let header =
                (this.state.widget && this.state.widget.widgetNameOverride) ||
                this.props.widgetName;
            if (!isNaN(header)) {
                header = LabelHelper.fetch(header);
            }

            if (
                typeof this.props.widget.i == typeof {} &&
                this.props.widget.i.header
            ) {
                if (!isNaN(this.props.widget.i.header)) {
                    header = LabelHelper.fetch(this.props.widget.i.header);
                } else {
                    header = this.props.widget.i.header;
                }
            }
            return (
                <div style={this.state.widgetWrapper.style.header}>
                    <div style={this.state.widgetWrapper.style.title}>
                        {header}
                    </div>
                </div>
            );
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }

    widgetWrapper(widget) {
        try {
            let style = {
                ...this.state.widgetWrapper.style.body,
                ...this.props.widget.overrideStyle,
            };
            if (!this.props.widget.default && this.state.widget) {
                style = { ...style, ...this.state.widget.style };
            }

            if (this.props.onNext || this.props.plain) {
                style = {};
            }

            if (this.state.widget && this.state.widget.accessLevel) {
                if (
                    !RolesHelper.hasAccessLevel(
                        this.state.widget.accessLevel
                    ) &&
                    !RolesHelper.isAgent()
                ) {
                    return (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "20px",
                                border: "solid thin lightgray",
                                borderRadius: "2px",
                                margin: "10px",
                            }}
                        >
                            <span>
                                You do not have access to view this content.
                            </span>
                        </div>
                    );
                }
            }

            return (
                <div style={style}>
                    {!this.props.widget.hideHeader && this.widgetHeader()}
                    {this.state.renderWidget}
                </div>
            );
        } catch (e) {
            return <div />;
        }
    }

    render() {
        return this.state.renderWidget && this.widgetWrapper();
    }
}

export default Radium(WidgetViewer);
